module.exports = __webpack_public_path__ + "static/media/img_top_gift@2x.827beeee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_top_gift@2x.png
// module id = 785
// module chunks = 0